//Customer, Employee and Supplier Detail Form Parameters
export const PARTY_FORM_PARAMS = {
  statusCode: "statusCode",
  blockedReason: "blockedReason",
  code: "code",
  customer: "customer",
  vatin: "vatin",
  name: "name",
  birthday: "birthday",
  salutationCode: "salutationCode",
  contactName: "contactName",
  phone: "phone",
  email: "email",
  mobile: "mobile",
  description: "description",
  street: "street",
  postalZipCode: "postalZipCode",
  city: "city",
  countryCode: "countryCode",
  categories: "categories",
  properties: "properties",
};
